import { delayedCall, dispatcher, ingenuity, killDelayedCall } from "@quest/base-core";
import { SlotConstantsBehavior, SlotEventConstantsBehavior, WinPresentationPanelBehavior } from "@quest/murka-games-behavior-panther/dist";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist";

import { GameParserModel } from "../Platform/GameParserModel";
import { gameConstants } from "../Constants/gameConstants";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { SoundConstantGame } from "../Constants/SoundConstantGame";

export class WinPresentationPanelGame extends WinPresentationPanelBehavior {
  public subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.SHOW_BAIT_SYM_ANIM, this.onShowBaitSymAnim, this);
  }
  public unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.SHOW_BAIT_SYM_ANIM, this.onShowBaitSymAnim, this);
  }
  /**overrided to clear winpresentation reels on win presentation suspend
   */
  protected stopAllWinLineSymbol(): void {
    this.clearSymReels();
    super.stopAllWinLineSymbol();
  }

  // Overrided to pass winning symbols data according to symbols lines win
  protected animateAllWinLineSymbol(): void {
    this.model.playLineWinAnim = true;
    const winLineData = (ingenuity.parserModel as platformModel).getWinLinesData()[
      (ingenuity.parserModel as platformModel).getWinLinesData().length -
      (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ]?.positions;
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASEGAME_WIN_ALPHA_ON_SYMBOL, winLineData);
    if (winLineData.length < 1) {
      return;
    }
    winLineData.sort(this.sortFirstColumn);
    winLineData.sort(this.sortSecondColumn);
    for (const element of winLineData) {
      this.animateLineSymbol(element);
    }
  }
  /**
   * overrided to play stack animation as per gridPosition for transparent symbol
   */
  protected playSymbolAnimation(reel: number, row: number, animationOnCurrentWinLine?: boolean): void {
    if (this.reelPanel.getReels()[reel].getSymbolByPos(row).symNum === gameConstants.TRANSPARENT_SYMBOL_ID) {
      let newRow = this.updateTransparentWithStackSymbol(reel, row);
      this.reelPanel.getReels()[reel].playAnimByPos(newRow, this.reelPanel.getAnimReels()[reel]);
    } else {
      this.reelPanel.getReels()[reel].playAnimByPos(row, this.reelPanel.getAnimReels()[reel]);
    }
    if (this.reelPanel.getReels()[reel].getSymbolByPos(row).symNum === gameConstants.MAN_SYMBOL_1X3_STACK_ID) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
        id: SoundConstantGame.CHARACTER_ORC_WIN, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
    }
    else if (this.reelPanel.getReels()[reel].getSymbolByPos(row).symNum === gameConstants.LADY_SYMBOL_1X3_STACK_ID) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
        id: SoundConstantGame.CHARACTER_ELF_WIN,
        vol: 1,
        loop: false,
        key: SlotConstantsBehavior.SOUND_LIST_PRELOAD,
      });
    }

  }
  /**
   * function is created to handle stack symbols which start from the above of reel masking
   * to handle tail of stack symbols
   * function will convert the winning transparent symbol with the stack which is present above the reel masking
   * checks the symbol num with the transparent and and update the stack number as per the grid position
   * the only function will play the stack animations from the reel panel and avoid the extra cloning and extra assets creation
   */
  private updateTransparentWithStackSymbol(reel: number, row: number): number {
    for (let i = row; i >= 0; i--) {
      if (
        this.reelPanel.getReels()[reel].getSymbolByPos(i).symNum === gameConstants.MAN_SYMBOL_1X3_STACK_ID ||
        this.reelPanel.getReels()[reel].getSymbolByPos(i).symNum === gameConstants.LADY_SYMBOL_1X3_STACK_ID
      ) {
        return i;
      }
    }
  }

  //Searches through the grid for bait symbols after Chest Reveal and plays the triggering Animation
  protected onShowBaitSymAnim(): void {
    let baitSymOffsets: number[][] = (ingenuity.parserModel as GameParserModel).getBaitSymOffsets();
    let i;
    let symbolID;
    if (ingenuity.configData.animationStopInScatterwin) {
      this.stopAllWinAnimations();
    }
    for (i = 0; i < baitSymOffsets.length; i++) {
      const reel: number = baitSymOffsets[i][0];
      const row: number = baitSymOffsets[i][1] + gameConstants.REEL_POSITION_OFFSET;
      symbolID = this.model.getReelGridElement(reel, row);

      this.playSymbolTriggerAnimationByID(symbolID, reel, row);
    }
    delayedCall(SlotConstants.TimerScatterAnimationEnded, 2500, function () {
      killDelayedCall(SlotConstants.TimerScatterAnimationEnded);

      dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);

      this.reelPanel.showAllSymbols();
      this.clearSymReels();
    }, (this));
  }
}
